import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "mt-4 px-1 text-14px" }, [
  /*#__PURE__*/_createTextVNode(" Ajak teman Anda bergabung menjadi Agen Mitra POS Lion Parcel dengan menggunakan kode referral dan dapatkan insentif "),
  /*#__PURE__*/_createVNode("b", null, "Rp500.000"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "mt-4 px-1 text-14px" }, " Bagikan kode referral ini dan ajak teman Anda bergabung menjadi Agen Mitra POS Lion Parcel. ", -1)
const _hoisted_3 = { class: "text-center mt-6" }
const _hoisted_4 = { class: "inline-block relative mr-4 text-12px xxl:text-14px" }
const _hoisted_5 = { class: "\n              absolute\n              inset-y-0\n              right-0\n              flex\n              items-center\n              px-5\n              bg-gray-lp-200\n              rounded-r\n            " }
const _hoisted_6 = { class: "text-14px mt-6 px-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "font-bold mt-6" }, "Syarat dan Ketentuan:", -1)
const _hoisted_8 = { class: "pl-6 mt-3" }
const _hoisted_9 = { class: "mt-6 flex items-center justify-center" }
const _hoisted_10 = { class: "p-4 cursor-pointer border rounded" }
const _hoisted_11 = { class: "flex flex-row w-full" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "w-8/12 pl-3 text-14px self-center" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold" }, "Daftar Sekarang!")
], -1)
const _hoisted_13 = { class: "w-4/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_SnackbarCopy = _resolveComponent("SnackbarCopy")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          title: "POS Referral",
          showFooter: false,
          width: "w-6/12",
          onClose: _ctx.onCloseModal
        }, {
          content: _withCtx(() => [
            _createVNode("img", {
              src: _ctx.bannerReferalFileLink,
              class: "w-full",
              alt: "banner-referral"
            }, null, 8, ["src"]),
            _hoisted_1,
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("input", {
                  value: _ctx.referralCode,
                  disabled: "",
                  class: "\n              text-red-lp-300\n              font-bold\n              text-20px\n              block\n              appearance-none\n              bg-white\n              border border-gray-lp-400\n              pl-3\n              py-3\n              rounded\n              leading-tight\n              focus:outline-none\n            "
                }, null, 8, ["value"]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Icons, {
                    name: "auto-copy",
                    onClick: _ctx.autoCopy,
                    class: "text-red-lp-100 cursor-pointer"
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createVNode("div", _hoisted_8, null, 512), [
                [_directive_sanitize_html, _ctx.term]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("a", {
                  href: 
              `https://lionparcel.com/agen/registration/submit?referral=${this.referralCode}#daftar`
            ,
                  target: "_blank",
                  rel: "noopener"
                }, [
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode("div", _hoisted_13, [
                      _createVNode("img", {
                        src: 
                    require(`@/app/ui/assets/svg/referral/referral-register-icon.svg`)
                  ,
                        class: "w-full",
                        alt: "referral-register-icon"
                      }, null, 8, ["src"])
                    ])
                  ])
                ], 8, ["href"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SnackbarCopy, {
      "model-value": _ctx.copyNotification,
      "onUpdate:modelValue": _ctx.removeCopyNotification
    }, null, 8, ["model-value", "onUpdate:modelValue"])
  ], 64))
}